import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { IdObjectFormModel } from "../../../../form/form-models/form-model";
import { IdObject } from "../../../../models/basicDto";
import {
  MoveAction,
  MultiItem,
  MultiItemFormModel,
  MultiLevelTableConfig,
  MultiWrapper,
} from "../multi-level-table.component";
import { TableRowComponent } from "../table-row/table-row.component";

@Component({
  selector: "app-table-group",
  standalone: true,
  imports: [TableRowComponent, CommonModule],
  templateUrl: "./table-group.component.html",
  styleUrl: "./table-group.component.scss",
})
export class TableGroupComponent<
    MI extends MultiItem<L> | MultiItemFormModel<MultiItem<L>, L, LFM>,
    L extends IdObject<number>,
    LFM extends IdObjectFormModel<any>,
  >
  implements AfterViewInit, OnInit, OnChanges
{
  @Input() item?: MultiWrapper<MI, MI extends MultiItem<L> ? L : LFM>;
  @Input() config!: MultiLevelTableConfig<MI, L, LFM>;

  @Input() isFirst = false;
  @Input() isLast = false;

  @Output() removeEvent = new EventEmitter<MI | (MI extends MultiItem<L> ? L : LFM)>();
  @Output() moveEvent = new EventEmitter<{
    action: MoveAction<MI | (MI extends MultiItem<L> ? L : LFM)>;
    item: MI | (MI extends MultiItem<L> ? L : LFM);
    direction: number;
  }>();
  @Output() selectEvent = new EventEmitter();
  @Output() addEvent = new EventEmitter();
  @ViewChild("groupTemplate") template: any;

  @Input() showCollapseButton: boolean = false;
  @Input() enableSelect: boolean = false;
  @Input() disableSelectButtons: boolean = false;
  @Input() showIndent = false;
  @Input() totalLevels = 1;
  @Input() currentLevel = 0;

  protected grayLevel: number = 0;

  constructor(
    private vcRef: ViewContainerRef,
    private cdRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    let l = this.totalLevels - this.currentLevel;
    this.grayLevel = Math.min(l * 100, 900);
    if (this.grayLevel === 100) {
      this.grayLevel = 0;
    }
  }

  ngAfterViewInit(): void {
    this.vcRef.createEmbeddedView(this.template);
    this.cdRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit();
  }
  removeItem(index: number) {
    this.item!.removeChild(index);
  }

  moveItem(
    action: MoveAction<MI | (MI extends MultiItem<L> ? L : LFM)>,
    item: MI | (MI extends MultiItem<L> ? L : LFM),
    index: number,
    direction: number
  ) {
    let otherIndex = index + direction;
    if (this.item?.Children) {
      let otherItem = this.item.Children[otherIndex];
      let otherOrder: number = action.getOrder(otherItem);
      let itemOrder: number = action.getOrder(item);
      action.setOrder(item, otherOrder);
      action.setOrder(otherItem, itemOrder);
      this.item.setChild(index, otherItem);
      this.item.setChild(otherIndex, item);
    }
  }

  addItemToGroup(itemToAdd: MI | (MI extends MultiItem<L> ? L : LFM)) {
    this.item?.addChild(itemToAdd);
    this.addEvent.emit();
  }

  collapse() {
    if (this.item) {
      this.item.collapse = !this.item.collapse;
    }
  }
  handleSelect(item: any) {
    if (this.item) {
      this.item.setSelected(
        this.item.wrapperChildren?.every((child) => child.isSelected == true) ?? false,
        true
      );
      this.selectEvent.emit();
    }
  }
}
